'use client';

import { isFilled } from '@prismicio/client';

import { useRef } from 'react';
import { Box, List, Dropdown, ListItem } from '@preventx/oxygen';

// Types
import { ISOLanguageKeys } from '@/types/language';
import { DropdownPanel as DropdownPanelElement } from '@/types/navigation/panel';

// Components
import { Link } from '@/components/Actions/Link';
import { Section } from '@/components/Site/Navigation/Standard/Section';

type DropdownPanelProps = {
  id: string;
  panel: DropdownPanelElement;
  language: string | ISOLanguageKeys;
};

export const DropdownPanel = ({ id, panel, language }: DropdownPanelProps) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const { label, meta, sectionOne, sectionTwo, sectionThree } = panel;

  return (
    <Dropdown component="div" ref={ref} id={id} label={label} variant="mega">
      {sectionOne && (
        <Section
          id={id}
          ref={ref}
          language={language}
          section={sectionOne}
          isNavigationDrawer={false}
        />
      )}

      {sectionTwo && (
        <Section
          id={id}
          ref={ref}
          language={language}
          section={sectionTwo}
          isNavigationDrawer={false}
        />
      )}

      {sectionThree && (
        <Section
          id={id}
          ref={ref}
          language={language}
          section={sectionThree}
          isNavigationDrawer={false}
        />
      )}

      {meta && (meta?.links ?? []).length > 0 && (
        <Box
          addRepel
          component="nav"
          aria-label={meta.label}
          className="dropdown__meta"
        >
          <List component="ul" addCluster>
            {meta.links.map((link, index) => {
              if (!isFilled.link(link)) {
                return null;
              }

              return (
                <ListItem key={`dropdown-panel-meta-${id}-${index + 1}`}>
                  <Link href={link} type="link" as="default" retainSearchParams>
                    {link.text}
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Dropdown>
  );
};
